var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.kinds,"label":"Tipo Transação","item-text":"title","item-value":"kinds","return-object":"","prepend-icon":"price_check"},model:{value:(_vm.kind),callback:function ($$v) {_vm.kind=$$v},expression:"kind"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }